export default class {
    constructor( fields ) {
        this.errors = '';
        this.fields = fields;
        this.callback = this.removeFeedback.bind(this);
    }

    get( field ) {
        if( this.hasError(field) ) {
            return this.errors[field]
        }
    }

    removeFeedback(ev) {
        ev.target.classList.remove('is-invalid');
        ev.target.parentNode.querySelector('.invalid-feedback').remove();
        ev.target.removeEventListener( ev.type, this.callback );
    }

    hasError( field ) {
        return this.errors[field]
    }

    clear( field ) {
        delete this.errors[field]
    }

    record( errors ) {
        this.errors = errors;
        this.fields.forEach( el => {
            if( this.hasError( el.id ) && ! el.classList.contains('is-invalid') ) {
                el.classList.add( 'is-invalid' )
                el.parentNode.appendChild( document.createRange().createContextualFragment(`
                    <div class="invalid-feedback">${this.get(el.id)}</div>
                `) );
                if( el.type === 'text' || el.type === 'textarea' ) {
                    el.addEventListener('keydown', this.callback);
                } else {
                    el.addEventListener('change', this.callback)
                }
            }
        })
    }
}